import React from "react";

import {List} from "semantic-ui-react";
import {S3Image} from "../../custom-common";


const DocumentExampleCard = ({title, image, listItems}) => (
    <div className={"neutral900Text claimsUploadInstructionsCard"}>
        <S3Image {...image}/>
        <p><b>{title}</b></p>
        <List bulleted className={'small claimUploadsList'}>
            {listItems.map((listItem, index) => <List.Item key={index} style={{display: 'flex', alignItems: 'center'}}>{listItem}</List.Item>)}
        </List>
    </div>
);

export default DocumentExampleCard;
